import { ValidateOrderStatus } from '@contexts/ValidateOrderStatus/ValidateOrderStatus'
import { ResetPersistence } from '@segments/Storage'
import * as React from 'react'

import { getOrderFromUrl } from '~logic/helpers/getOrderFromUrl'
import { SubmittedOrderProvider, useLoadSubmittedOrder } from '~shared/segments/SubmittedScreen'

import { SubmittedScreenResponsiveContent } from './components/SubmittedScreenResponsiveContent'
import { useLoadCustomerOrderNumber } from './hooks/useLoadCustomerOrderNumber'

type TProps = NoChildren

export const SubmittedScreen: React.FC<TProps> = () => {
  const { orderId } = getOrderFromUrl()
  const { order, error } = useLoadSubmittedOrder({ orderId })
  const customerNumber = useLoadCustomerOrderNumber({ orderId })

  if (!orderId || !customerNumber) {
    // to use customer order id, orderId and userToken must be present in the URL params
    // otherwise we couldn’t access the order -> redirect to homepage
    // this is actually handled in the submittedScreenSS
    // so this code should never run with current implementation
    return null
  }

  if (error) {
    // operation error handled within the useLoadSubmittedOrder hook
    return <ResetPersistence />
  }

  return (
    <SubmittedOrderProvider order={order}>
      <ValidateOrderStatus />
      <ResetPersistence />
      <SubmittedScreenResponsiveContent customerNumber={customerNumber} />
    </SubmittedOrderProvider>
  )
}
